import React from "react";
import rcss from '../../../Styles/reports.module.css';
import { observer } from "mobx-react-lite";
import { SetObjectToDisplayAsJson } from "../JsonOverlayView";
import { EncodingDetailsView } from "./common/EncodingDetailsView";
import { HasGetObjectByRequestId } from "../../../State/EvidenceDB/HasGetObjectByRequestId";
import { GetsDbEventsByIndex } from "../../../State/EvidenceDB/DbEventCache";
import { HasCallStackResolution } from "../../../lib/Causation/CallStackResolution";
import { ResultsForSearchTermSpecified } from "../SearchResultsObserver";
import { HasLicensePermissions } from "../../../State/EvidenceDB/LicensePermissions";

export const ResultsForSearchTermView = observer(({ resultsForSearchTerm, ...rest }: {
	resultsForSearchTerm: ResultsForSearchTermSpecified;
	getsDbEventsByIndex: GetsDbEventsByIndex;
} & HasCallStackResolution & HasLicensePermissions & HasGetObjectByRequestId & SetObjectToDisplayAsJson) => {
	const { searchTermAsSpecified, encodings, inferredTypeNames } = resultsForSearchTerm;
	return (
		<div className={rcss.indented}>
			<div className={rcss.searchTermFoundLine}>
				“<span className={rcss.searchTermFoundSpan}>{searchTermAsSpecified}</span>”
				{inferredTypeNames.size === 0 ? null : (<>
					&#32;labeled as&#32;
					<span>
						{[...inferredTypeNames.keys()].sort().map((inferredTypeName, index) => (
							<span key={inferredTypeName}>
								{index === 0 ? null : (<>,&#32;</>)}
								<span className={rcss.inferredTypeName}>{inferredTypeName}</span>
							</span>
						))}
					</span>
				</>)}
			</div>
			{encodings.map(encodingResults => (<EncodingDetailsView key={encodingResults.encodingString} {...{ encodingResults, ...rest }} />))}
		</div>
	);

});
